import { render, staticRenderFns } from "./dataRooms.vue?vue&type=template&id=7cbc20b4&scoped=true&"
import script from "./dataRooms.vue?vue&type=script&lang=js&"
export * from "./dataRooms.vue?vue&type=script&lang=js&"
import style0 from "./dataRooms.vue?vue&type=style&index=0&id=7cbc20b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbc20b4",
  null
  
)

export default component.exports